import { SubmitApplicationResult } from '@servicetitan/financing-api-client';
import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

export interface DecisionData extends SubmitApplicationResult {
    /** URL to redirect to when application is declined */
    declineRedirectUrl?: string | null;
}

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        __IS_DECISION_DATA_STORE_CREATED?: boolean;
        DecisionDataStore?: any;
    }
}

function useDecisionData(initialState: DecisionData) {
    const [decisionData, setDecisionData] = useState(initialState);

    return { decisionData, setDecisionData };
}

// if (!window.__IS_DECISION_DATA_STORE_CREATED) {
export const DecisionDataStore = createStore(useDecisionData);
// window.__IS_DECISION_DATA_STORE_CREATED = true;
// }

// export const DecisionDataStore = window.DecisionDataStore;

export type DecisionDataStore = ReturnType<typeof useDecisionData>;
